import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=89dff8d0&scoped=true"
import script from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=89dff8d0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dff8d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89dff8d0')) {
      api.createRecord('89dff8d0', component.options)
    } else {
      api.reload('89dff8d0', component.options)
    }
    module.hot.accept("./EmptyState.vue?vue&type=template&id=89dff8d0&scoped=true", function () {
      api.rerender('89dff8d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ui/emptyState/EmptyState.vue"
export default component.exports